import script from "./CurrentTickets.vue?vue&type=script&lang=ts&setup=true"
export * from "./CurrentTickets.vue?vue&type=script&lang=ts&setup=true"

import "./CurrentTickets.vue?vue&type=style&index=0&id=e7b9537c&lang=scss"

const __exports__ = script;

export default __exports__